import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect () {
    this.loadDefaults();
  }

  copyButtonHandler = (e) => {
    const button = e.target.closest('button');
    const { url } = button.dataset;
    // create a dummy input to copy from
    const dummyInput = document.createElement('textarea');
    dummyInput.value = url;
    document.body.appendChild(dummyInput);
    dummyInput.select();
    document.execCommand('copy');
    document.body.removeChild(dummyInput);

    // update the button text for two seconds
    button.querySelector('.purl-after-copy').classList.remove('purl-hide');
    button.querySelector('.purl-before-copy').classList.add('purl-hide');
    button.classList.add('elective-btn-after-copy');
    button.disabled = true;
    setTimeout(() => {
      button.disabled = false;
      button.querySelector('.purl-after-copy').classList.add('purl-hide');
      button.querySelector('.purl-before-copy').classList.remove('purl-hide');
      button.classList.remove('elective-btn-after-copy');
    }, 2000);
  };

  copyTextElement = (copyButton) => {
    copyButton.addEventListener('click', this.copyButtonHandler);
  };

  copyTextDisconnect = (copyButton) => {
    copyButton.removeEventListener('click', this.copyButtonHandler);
  };

  loadDefaults () {
    const inputs = document.querySelectorAll('.elective-item .js-copy-text');

    inputs.forEach((copyButton) => {
      if (copyButton) this.copyTextElement(copyButton);

      return () => {
        if (copyButton) this.copyTextDisconnect(copyButton);
      };
    });
  }
}
